/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import ColumnExportAPI from '@/api/ColumnExportAPI.js';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
export default {
	getConfigColumnExport: async function(context, payload) {
		let res = await httpClient.getAsync({
			url:
				ColumnExportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) +
				`/${payload.columnExportId}/${payload.type}`
		});
		if (res && res.Data && res.Success) {
			//Cập nhật lại layout Store
			context.commit('updateColumnExports', { Data: res.Data });
			return res.Data;
		}
		return res;
	},
	saveConfigColumnExport: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ColumnExportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/save`,
			data: payload
		});

		if (res && res.Data && res.Success) {
			//Cập nhật lại layout Store
			context.commit('updateColumnExports', { Data: res.Data });
		}
		return res;
	},

	resetCofigColumn: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: ColumnExportAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/reset`,
			data: payload
		});

		if (res && res.Data && res.Success) {
			//Cập nhật lại layout Store
			context.commit('updateColumnExports', { Data: res.Data });
		}
		return res;
	}
};
